import React from 'react';
import styled from 'styled-components';

import { TreeViewItemModel } from './tree-view-item';
import { TreeViewLevel } from './tree-view-level';
import { TreeViewContext } from './tree-view-state';

interface Props {
  items: TreeViewItemModel[];
  expandAll: boolean;
}

const TreeViewContent = (props: Props) => {
  const { setItems, expandAllItems } = React.useContext(TreeViewContext);

  React.useEffect(() => {
    setItems(props.items);
  }, [props.items, setItems]);

  React.useEffect(() => {
    if (props.expandAll) {
      expandAllItems();
    }
  }, [props.expandAll, expandAllItems]);

  return (
    <Component>
      <TreeViewLevel items={props.items} level={0} parent={null} />
    </Component>
  );
};

const Component = styled.nav`
  margin: 0;
  line-height: 1em;
  background-color: #fff;
  overflow: auto;
`;

export { TreeViewContent };
